import { logger } from '../logging/logger'
import type { FunkitUserIpInfo } from './useUserIpInfo'

const ALL_MATCH = '*'

export function isCountryBlocked(
  blockedList: readonly string[],
  userIpInfo: FunkitUserIpInfo,
): boolean {
  if (!userIpInfo.alpha2) {
    logger.log('isUserBlockedForCheckout_NoIpDetected')
    return true
  }

  const isBlocked =
    blockedList.includes(ALL_MATCH) || blockedList.includes(userIpInfo.alpha2)

  logger.info('isUserBlockedForCheckoutResult', {
    isBlocked,
    blockedList,
    alpha2: userIpInfo.alpha2,
  })
  return isBlocked
}
